import React, {useState} from "react";

import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {Country} from "../../../region/types/Country";
import {ViewType} from "../../../view_type/ViewType";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadSimpleRecommendationsOfferList} from "./ApplicationMultiLeadSimpleRecommendationsOfferList";
import {ApplicationMultiLeadSimpleRecommendationsPropertyList} from "./ApplicationMultiLeadSimpleRecommendationsPropertyList";

interface IRecommendedListProps {
    recommendationType: ApplicationMultiLeadRecommendationType;
    originalApplicationGeoPoint:
        | {
              coordinates: [number, number];
          }
        | undefined
        | null;
    originalApplicationCountry?: Country;
    recommended: {
        properties: IRecommendedProperty[];
        offers: IRecommendedOffer[];
    };
    viewType: ViewType | null;
    selected: number[];
    handleChange: (viewType: ViewType, recommendedItemID: number) => void;
    handlePinClick: (viewType: ViewType | null, recommendedItemID: number) => void;
    listTopSlot?: React.ReactNode;
    originalApplicationEstimatedPrice?: string | null;
    mainPropertyId?: IPropertyDetail["id"];
    allowToSelectMainProperty?: boolean;
}

export const ApplicationMultiLeadSimpleRecommendationsList = (props: IRecommendedListProps) => {
    const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

    const onListScroll = (event: React.UIEvent) => {
        const scrollTop = (event.target as HTMLElement).scrollTop;

        if (scrollTop > 0) {
            return setIsScrolledToBottom(true);
        }

        setIsScrolledToBottom(false);
    };

    switch (props.recommendationType) {
        // Note: `offer` recommendations can be shown only if they are delivered by backend.
        // If you want to see some, select rooms before sending application
        case ApplicationMultiLeadRecommendationType.OFFER: {
            return (
                <ApplicationMultiLeadSimpleRecommendationsOfferList
                    recommendedOffers={props.recommended.offers}
                    isScrolledToBottom={isScrolledToBottom}
                    onListScroll={onListScroll}
                    selected={props.selected}
                    handleChange={props.handleChange}
                />
            );
        }
        case ApplicationMultiLeadRecommendationType.PROPERTY: {
            return (
                <ApplicationMultiLeadSimpleRecommendationsPropertyList
                    mainPropertyId={props.mainPropertyId}
                    allowToSelectMainProperty={props.allowToSelectMainProperty}
                    recommendedProperties={props.recommended.properties}
                    selectedPropertyIds={props.selected}
                    isScrolledToBottom={isScrolledToBottom}
                    handleChange={props.handleChange}
                    handlePinClick={props.handlePinClick}
                    onListScroll={onListScroll}
                    originalApplicationGeoPoint={props.originalApplicationGeoPoint}
                    originalApplicationCountry={props.originalApplicationCountry}
                    listTopSlot={props.listTopSlot}
                    originalApplicationEstimatedPrice={props.originalApplicationEstimatedPrice}
                />
            );
        }
        default: {
            return null;
        }
    }
};
import React, {useState} from "react";

import {IRecommendedOffer} from "../../../offer/types/IRecommendedOffer";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {Country} from "../../../region/types/Country";
import {ViewType} from "../../../view_type/ViewType";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadSimpleRecommendationsOfferList} from "./ApplicationMultiLeadSimpleRecommendationsOfferList";
import {ApplicationMultiLeadSimpleRecommendationsPropertyList} from "./ApplicationMultiLeadSimpleRecommendationsPropertyList";

interface IRecommendedListProps {
    recommendationType: ApplicationMultiLeadRecommendationType;
    originalApplicationGeoPoint:
        | {
              coordinates: [number, number];
          }
        | undefined
        | null;
    originalApplicationCountry?: Country;
    recommended: {
        properties: IRecommendedProperty[];
        offers: IRecommendedOffer[];
    };
    viewType: ViewType | null;
    selected: number[];
    handleChange: (viewType: ViewType, recommendedItemID: number) => void;
    handlePinClick: (viewType: ViewType | null, recommendedItemID: number) => void;
    listTopSlot?: React.ReactNode;
    originalApplicationEstimatedPrice?: string | null;
    mainPropertyId?: IPropertyDetail["id"];
    allowToSelectMainProperty?: boolean;
}

export const ApplicationMultiLeadSimpleRecommendationsList = (props: IRecommendedListProps) => {
    const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

    const onListScroll = (event: React.UIEvent) => {
        const scrollTop = (event.target as HTMLElement).scrollTop;

        if (scrollTop > 0) {
            return setIsScrolledToBottom(true);
        }

        setIsScrolledToBottom(false);
    };

    switch (props.recommendationType) {
        // Note: `offer` recommendations can be shown only if they are delivered by backend.
        // If you want to see some, select rooms before sending application
        case ApplicationMultiLeadRecommendationType.OFFER: {
            return (
                <ApplicationMultiLeadSimpleRecommendationsOfferList
                    recommendedOffers={props.recommended.offers}
                    isScrolledToBottom={isScrolledToBottom}
                    onListScroll={onListScroll}
                    selected={props.selected}
                    handleChange={props.handleChange}
                />
            );
        }
        case ApplicationMultiLeadRecommendationType.PROPERTY: {
            return (
                <ApplicationMultiLeadSimpleRecommendationsPropertyList
                    mainPropertyId={props.mainPropertyId}
                    allowToSelectMainProperty={props.allowToSelectMainProperty}
                    recommendedProperties={props.recommended.properties}
                    selectedPropertyIds={props.selected}
                    isScrolledToBottom={isScrolledToBottom}
                    handleChange={props.handleChange}
                    handlePinClick={props.handlePinClick}
                    onListScroll={onListScroll}
                    originalApplicationGeoPoint={props.originalApplicationGeoPoint}
                    originalApplicationCountry={props.originalApplicationCountry}
                    listTopSlot={props.listTopSlot}
                    originalApplicationEstimatedPrice={props.originalApplicationEstimatedPrice}
                />
            );
        }
        default: {
            return null;
        }
    }
};
